import { createReducer } from '@ngrx/store';

import { produceOn } from 'app/_state/produce-on';

import * as ACTIONS from './org-context-actions';
import { initialState } from './org-context-state';

const _orgContextReducers = createReducer(initialState,
  produceOn(ACTIONS.SET_ORG_NAME, (state, props) => {
    state.org_name = props.payload?.name;
  }),
);

export function orgContextReducers(state, action) {
  return _orgContextReducers(state, action);
}
